import axios from "../common";

export const ApiProductsAttributes = async () => {
    let url = "/coverage_simulator/products/list"
    return await axios.get(url, {withCredentials: true})
}